<template>
    <div>
      <div class="white_bg">
        <div class="analyse_item">
          <div class="analyse_header">
            <NodeName 
              :node_name="'功能评测得分：'+data.base_score+'分'"
            />
            <div class="expand_controls">
              <el-button 
                type="primary" 
                size="small" 
                @click="toggleExpandAll"
                :icon="isExpanded ? 'ArrowUp' : 'ArrowDown'"
              >
                {{ isExpanded ? '全部折叠' : '全部展开' }}
              </el-button>
            </div>
          </div>
          <tree-table-base
            ref="treeTableRef"
            v-loading="tree_table_loading"
            :data_type="1"
            :model_list="model_list"
            :data="tree_table_data"
            :defaultExpandAll="false"
          >
          </tree-table-base>
        </div>
      </div>
    </div>
     
    </template>
    <script>
    import { ElMessage } from "element-plus";
    import { getCarSummaryDataV2 ,getCarScoreV2} from "@/api";
    import { ref } from "vue";
    import { useRoute } from "vue-router";
    import TreeTableBase from "@/components/v2/common/views/treeTable/TreeTableBase.vue"
    import NodeName from "@/components/common/views/NodeName.vue";
    
    export default {
      name: "Analyse",
      components: {
        TreeTableBase,
        NodeName
      },
      setup() {
        const route = useRoute();
        let { model_id,report_id,node_id=""} = route.query;
        const cur_node_id = ref(node_id);
        const _getData = () => {
          getCarSummaryDataV2({
            model_id,
            get_base:1
          }).then((res) => {
            if (res.code == 200) {
              const callData = res.data;
              callData.stars_per = Number(res.data.stars_per);
              const levelOneIds = [];
              if (callData.performance_score_detail) {
                callData.performance_score = 0;
              }
              data.value = callData;
              data.value.levelOneIds = levelOneIds;
              model_list.value = [{model_id,report_id,model_name:callData.brand+" "+callData.model_name}]
            } else if (res.code == 501) {
              //未登录处理
            } else {
              ElMessage.error(res.message);
            }
          })
          
          // 直接获取功能评测数据并展示tree-table
          getCarScoreV2({
            model_id,
            report_id,
            node_id:4921,
            // need_own:1
          }).then(res=>{
            // 直接使用返回的数据，不需要查询child
            tree_table_loading.value = true;
            tree_table_data.value = [res];
            tree_table_loading.value = false;
          })
        };

        const data = ref({});
        const model_list = ref([{model_id,report_id,model_name:data.value.model_name}])
        const tree_table_loading = ref(false);
        const tree_table_data = ref(null);
        const treeTableRef = ref(null);
        
        // 展开/折叠状态管理
        const isExpanded = ref(false);
        
        // 切换展开/折叠状态
        const toggleExpandAll = () => {
          isExpanded.value = !isExpanded.value;
          if (treeTableRef.value) {
            treeTableRef.value.toggleAllRows(isExpanded.value);
          }
        };

        // 移除handleTreeTableData函数，不再需要

        _getData();

        return {
          data,
          tree_table_data,
          model_list,
          tree_table_loading,
          cur_node_id,
          treeTableRef,
          isExpanded,
          toggleExpandAll
        };
      },
    };
    </script>
    <style scoped lang="less">
    .white_bg {
      padding: 37px 48px;
      min-width: 1090px;
      display: inline-block;
    }
    
    .analyse_item {
      position: relative;
      margin-bottom: 30px;
      
      &.analyse_item2 {
        min-height: 500px;
        margin-bottom: 0;
        h2{
          margin-bottom: 10px;
        }
      }
      
      .analyse_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        
        .expand_controls {
          display: flex;
          align-items: center;
          gap: 10px;
        }
      }
      
      h2 {
        position: relative;
        padding-left: 31px;
        font-size: 18px;
        color: #404248;
        font-weight: bold;
        margin-bottom: 33px;
        line-height: 20px;
        &:before {
          position: absolute;
          left: 0;
          top: 0;
          content: "";
          width: 5px;
          height: 20px;
          background-color: #4ed6f7;
          border-radius: 2px;
        }
        strong {
          margin-left: 8px;
          color: #e7816e;
        }
      }
    }
    </style>